import React from 'react';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';

export interface LayoutProps 
{
    children?: React.ReactNode;
}

interface LayoutState
{
	refresh: boolean;
}


export class PublicLayout extends React.Component<LayoutProps, LayoutState>
{
	constructor(props: LayoutProps)
	{
		super(props);

		this.state = {
			refresh: false
		};
		
	}

	public render()
	{
		return <div className='main-container'>
			<PublicHeader onLanguageChangedCallback={this.onLanguageChanged.bind(this)} />
			<div className='content-container' key={this.state.refresh ? 1 : 0} >
				{this.props.children}
			</div>
			<PublicFooter />
        </div>;
	}

	private onLanguageChanged()
	{
		this.setState({
			refresh: !this.state.refresh
		});
	}
}